<div class="login-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-image">
                <img src="assets/img/login.jpg" alt="Spital Pașcani" />
            </div>
        </div>
        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-content">
                <!-- Buton Înapoi -->
                <div></div>
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="login-form">
                            <!-- Logo Pașcani complet -->
                            <div class="logo"></div>
                            <h3>
                                Bine ai venit la Portalul de Pacienti al
                                Spitalului CF Pascani
                            </h3>

                            <!-- Paragraful pentru register (lipsă în versiunea ta) -->
                            <p>
                                Nu ai cont?
                                <a
                                    href="javascript:void(0)"
                                    (click)="openRegisterInfo()"
                                    style="
                                        color: rgb(255, 25, 73);
                                        font-size: 16px;
                                        text-decoration: underline;
                                    "
                                >
                                    Urmeaza pasii de aici.
                                </a>
                            </p>

                            <form>
                                <div class="form-group">
                                    <label>Username / Email</label>
                                    <input
                                        [(ngModel)]="loginData.username"
                                        [ngModelOptions]="{ standalone: true }"
                                        type="text"
                                        placeholder="Username / Email"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Parolă</label>
                                    <input
                                        [(ngModel)]="loginData.password"
                                        [ngModelOptions]="{ standalone: true }"
                                        type="password"
                                        placeholder="Parola ta"
                                        class="form-control"
                                    />
                                </div>

                                <!-- Checkbox Ține-mă minte -->
                                <!-- <div class="form-group form-check">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="rememberMe"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="rememberMe"
                                        >Ține-mă minte pe acest
                                        dispozitiv</label
                                    >
                                </div> -->

                                <!-- Am uitat parola -->
                                <!-- <div class="form-group text-end">
                                    <a
                                        routerLink="/forgot-password"
                                        class="forgot-link"
                                        >Am uitat parola?</a
                                    >
                                </div> -->

                                <button
                                    type="button"
                                    (click)="login(loginData)"
                                    class="btn btn-primary btn-block"
                                >
                                    Autentificare
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- MODAL INSTRUCȚIUNI ÎNREGISTRARE -->
<div
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    *ngIf="showRegisterInfoModal"
    style="display: block; background: rgba(0, 0, 0, 0.5)"
>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Cum obții cont pentru Portalul Pacientului
                </h5>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="closeRegisterInfo()"
                ></button>
            </div>

            <div class="modal-body">
                <ol>
                    <li>Descărcați formularul de cerere (PDF).</li>
                    <li>
                        Completați formularul, semnați-l olograf sau cu
                        semnătură electronică și atașați copia CI.
                    </li>
                    <li>
                        Trimiteți documentele la adresa:
                        <a href="mailto:portal@spitalcfpascani.ro">
                            portal@spitalcfpascani.ro </a
                        >.
                    </li>
                    <li>
                        După procesare, veți primi pe email user-ul și parola
                        pentru acces.
                    </li>
                </ol>

                <!-- Buton/Link descărcare formular -->
                <div class="mt-3">
                    <a
                        class="btn btn-outline-primary"
                        href="assets/formulare/Formular_acces_portal_Spital_CF_Pascani_retusat.pdf"
                        download="cerere-cont-portal-pacient.pdf"
                    >
                        Descarcă formularul de cerere (PDF)
                    </a>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="closeRegisterInfo()"
                >
                    Închide
                </button>
            </div>
        </div>
    </div>
</div>
